<div class="theme-wizard mb-5 mb-lg-0 mb-xl-5 mb-xxl-0 h-100">
  <div class="pc-wizard">
    <div class="pc-wizard-nav-container pt-3 pb-2">
      <ul
        class="pc-wizard-nav nav nav-pills mb-3"
        role="tablist"
        id="pill-tab2"
      >
        <li
          *ngFor="let step of items(); let i = index"
          class="nav-item"
          role="presentation"
        >
          <button
            class="nav-link {{ getClassForStepButton(step) }} shadow-sm"
            [attr.data-wizard-step]="i + 1"
            data-bs-toggle="pill"
            [attr.data-bs-target]="'#form-wizard-progress-tab' + (i + 1)"
            type="button"
            role="tab"
            [attr.aria-controls]="'form-wizard-progress-tab{{ i + 1 }}'"
            [attr.aria-selected]="getIsActive(step)"
            (click)="onStepSelection($event, i)"
          >
            <div>
              @if(step.icon !== undefined){
              <span class="nav-item-circle me-2">{{ step.icon }}</span>
              }
              <span class="title">{{ step.title | translate }}</span>
            </div>
            @if (showIcons()) {
            <span [class]="getClassForIcon(step)"></span> }
          </button>
        </li>
      </ul>
      <ng-content select="[wizardNavExtra]"></ng-content>
    </div>
    <div class="py-3 pc-wizard-content-container">
      <div class="tab-content">
        <div class="pb-3">
          <ng-content></ng-content>
        </div>
        @if (showFooter()) {
        <div class="wizard-footer">
          <div class="px-sm-3 px-md-5">
            <ul class="pager wizard list-inline mb-0">
              <li class="previous">
                @if(prevButtonHasChevron()){
                <button
                  class="btn btn-falcon-default btn-sm me-3 {{
                    prevButtonEnabled() ? '' : 'disabled'
                  }}"
                  type="button"
                  (click)="prevButtonClicked.emit()"
                >
                  <span
                    class="fas fa-chevron-left me-2"
                    data-fa-transform="shrink-3"
                  ></span
                  >{{ prevButtonText() | translate }}
                </button>
                }@else {
                <button
                  class="btn btn-falcon-default btn-sm me-3 {{
                    prevButtonEnabled() ? '' : 'disabled'
                  }}"
                  type="button"
                  (click)="prevButtonClicked.emit()"
                >
                  {{ prevButtonText() | translate }}
                </button>
                }
              </li>
              <li class="next">
                @if (nextButtonContentTpl(); as nextTpl) {
                <button
                  class="btn btn-primary btn-sm {{
                    nextButtonEnabled() ? '' : 'disabled'
                  }}"
                  type="button"
                  [attr.title]="
                    nextButtonTitleKey()
                      ? (nextButtonTitleKey()! | translate)
                      : null
                  "
                  (click)="nextButtonClicked.emit()"
                >
                  <ng-container *ngTemplateOutlet="nextTpl" />
                </button>
                } @else if (nextButtonHasChevron()) {
                <button
                  class="btn btn-primary btn-sm {{
                    nextButtonEnabled() ? '' : 'disabled'
                  }}"
                  type="submit"
                  (click)="nextButtonClicked.emit()"
                >
                  {{ nextButtonText() | translate
                  }}<span
                    class="fas fa-chevron-right ms-2"
                    data-fa-transform="shrink-3"
                  >
                  </span>
                </button>
                } @else {
                <button
                  class="btn btn-primary btn-sm {{
                    nextButtonEnabled() ? '' : 'disabled'
                  }}"
                  type="submit"
                  (click)="nextButtonClicked.emit()"
                >
                  {{ nextButtonText() | translate }}
                </button>
                }
              </li>
            </ul>
          </div>
        </div>
        }
      </div>
    </div>
  </div>
</div>
